<script setup lang="ts" generic="T">
import CloseIcon from '~/assets/icons/close/16/close-xs.svg'

const props = defineProps<{
  id: string | number
  name: string | number
  category: T
  isSelected?: boolean,
  hasCloseBtn?: boolean,
}>();

const emits = defineEmits(['select-value'])

function setSelectedStatus() {
  const { id, name, isSelected, category } = props;

  emits('select-value', {
    id,
    name,
    isSelected: !isSelected,
    category
  })
}
</script>

<template>
  <div
    class="filter-checkbox"
    :class="[
      isSelected && 'active',
      hasCloseBtn && 'filter-checkbox_has-close'
    ]"
  >
    <label>
      <input
        class="filter-checkbox__input"
        type="checkbox"
        :value="isSelected"
        @change="setSelectedStatus"
      />
        {{ name }}
        <span
          class="filter-checkbox__remove"
          v-if="isSelected && hasCloseBtn"
        >
          <CloseIcon />
        </span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.filter-checkbox {
  display: flex;
  align-items: center;

  &_has-close {
    pointer-events: none;
    color: $content_white;
    .label {
      background-color: $control-bg_black;
    }
  }

  &.active {
    label {
      background-color: $control-bg_black;
      color: $content_white;
    }
  }

  &__remove {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    pointer-events: auto;
  }

  label {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    height: 36px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: $control-bg_neutral;
    cursor: pointer;
    @include font(14px, 20px);
    white-space: nowrap;
  }

  input {
    display: none;
  }
}
</style>
